"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractClassException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractClassException"));

var _AbstractMethodException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractMethodException"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * This class is used for providing general functionality for a service.
 *
 * @abstract
 */
var AbstractService = /*#__PURE__*/function () {
  /**
   * Class constructor.
   */
  function AbstractService() {
    _classCallCheck(this, AbstractService);

    if (this.constructor === AbstractService) {
      throw new _AbstractClassException.default();
    }
  }
  /**
   * Minifies an XML string.
   *
   * @param {String} xml XML string to minify.
   * @return {String} Minified XML.
   */


  _createClass(AbstractService, [{
    key: "_minifyXml",
    value: function _minifyXml(xml) {
      return xml.replace(/>([\n\r\t ]+)([^<])</g, '><').replace(/[ ]+/g, ' ').replace(/[\r\n]/g, '').replace(/^ </, '<').replace(/> $/, '>');
    }
    /**
     * Handles JSON response and returns a promise.
     * Throws an error if the response has failed.
     *
     * @throws ServiceException
     * @param {Response} response Response object.
     * @return {Promise} Promise object.
     */

  }, {
    key: "_handleJsonResponse",
    value: function _handleJsonResponse(response) {
      if (!response.ok) {
        throw new _ServiceException.default('Server responded with ' + response.status + ' ' + response.statusText, this.constructor.factoryName, response.status);
      }

      return response.json();
    }
    /**
     * Throws an error if the provided response has failed, otherwise it will just return the response.
     *
     * @throws ServiceException
     * @param {Response} response Response object.
     * @return {Response} Response object.
     */

  }, {
    key: "_handleTextResponse",
    value: function _handleTextResponse(response) {
      if (!response.ok) {
        throw new _ServiceException.default('Server responded with ' + response.status + ' ' + response.statusText, this.constructor.factoryName, response.status);
      }

      return response.text();
    }
    /**
     * Throws an error if the provided response has failed, otherwise it will just return the response.
     *
     * @throws ServiceException
     * @param {Response} response Response object.
     * @return {Response} Response object.
     */

  }, {
    key: "_handleResponse",
    value: function _handleResponse(response) {
      if (!response.ok) {
        throw new _ServiceException.default('Server responded with ' + response.status + ' ' + response.statusText, this.constructor.factoryName, response.status);
      }

      return response;
    }
    /**
     * Wraps rejection errors to make sure that a ServiceException always is returned for.
     *
     * @param {Function} reject Reject to be called.
     * @param {Error} error Error object.
     */

  }, {
    key: "_rejectWrapper",
    value: function _rejectWrapper(reject, error) {
      var returnError = error;

      if (!(error instanceof _ServiceException.default)) {
        returnError = new _ServiceException.default(error.message, this.constructor.factoryName);
        returnError.stack = error.stack;
      }

      reject(returnError);
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @abstract
     * @return {String} Factory name.
     */

  }], [{
    key: "getInstance",

    /**
     * Returns a single instance of AbstractService.
     *
     * @return {AbstractService} AbstractService.
     */
    value: function getInstance() {
      this._instance = this._instance instanceof this ? this._instance : new this();
      return this._instance;
    }
    /**
     * Clears the stored instance that gets created by getInstance().
     */

  }, {
    key: "clearInstance",
    value: function clearInstance() {
      delete this._instance;
    }
  }, {
    key: "factoryName",
    get: function get() {
      throw new _AbstractMethodException.default();
    }
  }]);

  return AbstractService;
}();

exports.default = AbstractService;